import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './Button';
import { Select } from './Field';
import { PAGE_SIZES, type PageSize } from '@/lib/usePagedList';

export function PaginationBar({
  page,
  pageSize,
  onPageSize,
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  shown,
  loading,
  noun = 'items',
  total,
}: {
  page: number;
  pageSize: PageSize;
  onPageSize: (s: PageSize) => void;
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  shown: number;
  loading?: boolean;
  noun?: string;
  total?: number;
}) {
  const start = shown === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = (page - 1) * pageSize + shown;
  return (
    <nav className="pf-pagination" aria-label={`${noun} pagination`}>
      <span className="pf-pagination-count tabular" aria-live="polite">
        {shown === 0 ? `No ${noun}` : `${start}–${end}`} {total !== undefined && shown > 0 ? `of ${total}` : null} <span className="subtle">· page {page}</span>
      </span>
      <div className="pf-pagination-controls">
        <label className="pf-pagination-size">
          <span className="subtle">Rows</span>
          <Select aria-label="Rows per page" value={String(pageSize)} onChange={(e) => onPageSize(Number(e.target.value) as PageSize)} options={PAGE_SIZES.map((s) => ({ value: String(s), label: String(s) }))} />
        </label>
        <Button size="sm" variant="secondary" icon={<ChevronLeft size={15} />} onClick={onPrev} disabled={!hasPrev || loading} aria-label="Previous page">
          Prev
        </Button>
        <Button size="sm" variant="secondary" iconRight={<ChevronRight size={15} />} onClick={onNext} disabled={!hasNext || loading} aria-label="Next page">
          Next
        </Button>
      </div>
    </nav>
  );
}

